import {
    GET_USER_DATA,
    GET_USER_DATA_SUCCESS,
    GET_USER_DATA_ERROR,
    LOGOUT_USER,
    LOGOUT_USER_SUCCESS,
    ADD_PROCEEDING_SUCCESS,
    ADD_PROCEEDING,
    ADD_PROCEEDING_ERROR,
    REMOVE_PROCEEDING,
    REMOVE_PROCEEDING_SUCCESS,
    REMOVE_PROCEEDING_ERROR
} from '../types';
//Cookie
import alertMessages from '../helpers/alertMessages';
import messages from '../constants/messages';
import api from '../helpers/api';
import apiMethods from '../constants/apiMethods';
import CookieService from '../services/CookieService';
import { isJwtTokenStored } from '../helpers/authHelper';
//Get user data
export function getUserDataAction(history) {
    return async (dispatch) => {
        //Inicio la ejecución
        dispatch( getUserData() );
        //Verifico que exista el token
        if(isJwtTokenStored()){
            //Ejecuto la consutla
            try{
                //Cargo la espera
                // alertMessages.waiting(messages.LOADING.USER_DATA);
                const response = await api.get(apiMethods.USER_DATA);
                //Obtengo los datos
                const res = response.data;
                //Llamo al success
                dispatch( getUserDataSuccess(res.data) );
            }catch(error){
                console.log(error);
                const response = error.response;
                let data = {
                    data: null,
                    message: messages.ERROR.SERVER
                };
                //Verifico si hay error
                if(response){
                    data = response.data;
                }
                //Llamo al dispatch
                dispatch( getUserDataError(data) );
                //Oculto la espera
                // alertMessages.close();
            }
        }
    }
}

const getUserData = () => ({
    type: GET_USER_DATA,

})

const getUserDataSuccess = user => ({
    type: GET_USER_DATA_SUCCESS,
    payload: user
})

const getUserDataError = error => ({
    type: GET_USER_DATA_ERROR,
    payload: error
})

//Logout
export function logoutAction() {
    return async (dispatch) => {
        //Inicio la ejecución
        dispatch( logout() );
        //Elimino la cookie
        CookieService.remove(process.env.REACT_APP_TN, {path: '/'});
        //Llamo al success
        dispatch( logoutSuccess() );
        //Redirecciono
        window.location = process.env.REACT_APP_LOGOUT_URL;
    }
}

const logout = () => ({
    type: LOGOUT_USER,

})
//Si el category se guarda ok
const logoutSuccess = () => ({
    type: LOGOUT_USER_SUCCESS,
    payload: null
})

//ADD USER PROCEEDING
export function addProceedingAction(proceeding) {
    return async (dispatch) => {
        //Inicio la ejecución
        dispatch( addProceeding() );
        //Ejecuto la consutla
        try{
            //Muestro espera
            alertMessages.waiting(messages.ACTIONS.ADD_PROCEEDING)
            //Busco el token de usuario
            //Genero los parámetros
            const params = {
                jurisdiction: proceeding.jurisdiction_id,
                proceeding: proceeding.procid,
                unit: proceeding.juzgid
            }
            //Inicializo la respuesta
            const response = await api.post(apiMethods.MY_PROCEEDINGS, params);
            //Obtengo los datos
            const res = response.data;
            //Llamo al success
            dispatch( addProceedingSuccess(res.data) );
            //Oculto espesra
            alertMessages.close();
            //Muestro mensaje de agregado
            alertMessages.success(messages.SUCCESS.PROCEEDING_ADDED);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: messages.ERROR.SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( addProceedingError(data) );
            //Oculto espesra
            alertMessages.close();
            //Muestro mensaje
            alertMessages.error(data.message);
        }
    }
}

const addProceeding = () => ({
    type: ADD_PROCEEDING,

})

const addProceedingSuccess = userProceeding => ({
    type: ADD_PROCEEDING_SUCCESS,
    payload: userProceeding
})

const addProceedingError = error => ({
    type: ADD_PROCEEDING_ERROR,
    payload: error
})

//REMOVE USER PROCEEDING
export function removeProceedingAction(proceeding) {
    return async (dispatch) => {
        //Inicio la ejecución
        dispatch( removeProceeding() );
        //Ejecuto la consutla
        try{
            //Muestro espera
            alertMessages.waiting(messages.LOADING.DELETING_PROCEEDING);
            //Busco el token de usuario
            //Inicializo la respuesta
            await api.delete(`${apiMethods.MY_PROCEEDINGS}/${proceeding.id}`);
            //Obtengo los datos
            // const res = response.data;
            //Llamo al success
            dispatch( removeProceedingSuccess(proceeding) );
            //Oculto espera
            alertMessages.close();
            //Muestro mensaje de agregado
            alertMessages.success(messages.SUCCESS.PROCEEDING_DELETED);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: messages.ERROR.SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( removeProceedingError(data) );
            //Oculto espesra
            alertMessages.close();
            //Muestro mensaje
            alertMessages.error(data.message);
        }
    }
}

const removeProceeding = () => ({
    type: REMOVE_PROCEEDING,

})

const removeProceedingSuccess = userProceeding => ({
    type: REMOVE_PROCEEDING_SUCCESS,
    payload: userProceeding
})

const removeProceedingError = error => ({
    type: REMOVE_PROCEEDING_ERROR,
    payload: error
})